import { render, staticRenderFns } from "./MyDealsTable.vue?vue&type=template&id=7958d72e&lang=pug&"
import script from "./MyDealsTable.vue?vue&type=script&lang=ts&"
export * from "./MyDealsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports